const middleware = {}

middleware['authenticated'] = require('..\\middleware\\authenticated.ts')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['enrollment-guard'] = require('..\\middleware\\enrollment-guard.ts')
middleware['enrollment-guard'] = middleware['enrollment-guard'].default || middleware['enrollment-guard']

middleware['globaliri'] = require('..\\middleware\\globaliri.ts')
middleware['globaliri'] = middleware['globaliri'].default || middleware['globaliri']

middleware['hideiri'] = require('..\\middleware\\hideiri.ts')
middleware['hideiri'] = middleware['hideiri'].default || middleware['hideiri']

middleware['password-expired'] = require('..\\middleware\\password-expired.ts')
middleware['password-expired'] = middleware['password-expired'].default || middleware['password-expired']

middleware['session'] = require('..\\middleware\\session.ts')
middleware['session'] = middleware['session'].default || middleware['session']

middleware['showiri'] = require('..\\middleware\\showiri.ts')
middleware['showiri'] = middleware['showiri'].default || middleware['showiri']

middleware['tc-password-protect'] = require('..\\middleware\\tc-password-protect.ts')
middleware['tc-password-protect'] = middleware['tc-password-protect'].default || middleware['tc-password-protect']

export default middleware
